import { useParams } from 'react-router-dom'

import { PurchaseRequestDetailDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import Attachments from 'modules/procurement/components/purchaseRequests/PurchaseRequestDetail/Attachments'

const MyPurchaseRequestDetailAttachmentsPage = () => {
  const { id } = useParams()
  const { company } = useCurrentSession()

  const { loading, data, error } = useQuery(PurchaseRequestDetailDocument, {
    variables: {
      companyId: company.id,
      id: Number(id),
    },
  })

  const purchaseRequest = data?.procurement?.purchaseRequest
  const canManagePurchaseRequests = data?.procurement?._policies?.purchaseRequestManage.can ?? false

  const hasDataCollectionsFeature =
    data?.features?.featuresConnection?.nodes?.some(
      (feature) => feature.name === 'dev_procurement_data_collections' && feature.enabled
    ) ?? false

  return (
    <ResponsivePage.Body
      variant="wide"
      authorized={canManagePurchaseRequests}
      loading={loading}
      error={error}
    >
      {purchaseRequest && (
        <Attachments
          purchaseRequest={purchaseRequest}
          displayDataCollection={hasDataCollectionsFeature}
        />
      )}
    </ResponsivePage.Body>
  )
}

export default MyPurchaseRequestDetailAttachmentsPage
